import React from 'react';
import { Controller, useForm } from 'react-hook-form';
import { Button } from 'primereact/button';
import InputErrorMessage from 'components/UI/InputErrorMessage/InputErrorMessage';
import LocationInputWithSuggestions from 'modules/calendar/Components/CreateEventModal/Components/EventLocation/LocationInputWithSuggestions';
import { createContact } from 'services/contact';
import { useToast } from 'context/ToastContext';
import { toastConstant } from 'constants/toastmessage';
import { useCalendarUI } from 'modules/calendarv2/context/CalendarUIContext';

function AddLocationForm({ setAddLocation, setValue }) {
  const { setLocationsList } = useCalendarUI();
  const { addToast } = useToast();

  const {
    control: control2,
    resetField: resetField2,
    formState: { errors: errors2 },
    handleSubmit: handleSubmit2,
  } = useForm();

  const handleAddLocation = (data) => {
    let obj = {
      contact_type: 'location',
      title: data.newLocation,
      email: '',
      phone: '',
      country: 'United States',
      country_code: '+1',
    };
    addNewLocation(obj);
    setAddLocation(false);
    resetField2('newLocation');
  };

  function addNewLocation(data) {
    createContact(data)
      .then((response) => {
        setLocationsList((prev) => [...prev, { label: data.title, value: response?.data?.contact_id }]);
        setValue('location', response?.data?.contact_id);
        addToast(false, toastConstant.toasterType.SUCCESS, toastConstant.api.SUCCESS, toastConstant.message.LOCATION_CREATE_SUCCESS);
      })
      .catch((err) => {
        console.log(err);
        addToast(false, toastConstant.toasterType.INFO, toastConstant.api.FAILED, toastConstant.message.LOCATION_CREATE_FAILURE);
      });
  }

  return (
    <div>
      <div className="p-inputgroup align-items-center">
        <Controller
          name="newLocation"
          control={control2}
          rules={{ required: true }}
          defaultValue=""
          render={({ field }) => (
            <LocationInputWithSuggestions value={field.value} onChange={field.onChange} className="" placeholder="Add new location" />
          )}
        />
        <Button
          icon="pi pi-times"
          className="p-button-secondary outline me-1"
          type="button"
          style={{
            width: '32px',
            height: '32px',
            padding: '0',
            minWidth: '32px',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            backgroundColor: '#fff',
            marginLeft: '8px',
          }}
          onClick={() => {
            setAddLocation(false);
            resetField2('newLocation');
          }}
        />
        <Button
          icon="pi pi-check"
          className="p-button-secondary outline"
          type="button"
          style={{
            width: '32px',
            height: '32px',
            padding: '0',
            minWidth: '32px',
            border: '1px solid #e0e0e0',
            borderRadius: '4px',
            backgroundColor: '#fff',
            marginLeft: '4px',
          }}
          onClick={handleSubmit2(handleAddLocation)}
        />
      </div>
      <div>{errors2?.newLocation && <InputErrorMessage>Enter valid location</InputErrorMessage>}</div>
    </div>
  );
}

export default AddLocationForm;
